<script>
  import reveal from '../lib/actions/reveal.js';
  import SectionHeader from '../lib/ui/SectionHeader.svelte';
  // Updated to use the new 'w*' logos added to /public/media
  const logos = [
    {src:'/media/wmckin.png', alt:'McKinsey'},
    {src:'/media/wEY.png', alt:'EY'},
    {src:'/media/wDBSBankLogov3.png', alt:'DBS Bank'},
    {src:'/media/wBNBchainv2.png', alt:'BNB Chain'},
    {src:'/media/wvirtuals-logo.png', alt:'Virtuals'}
  ];
</script>

<section id="team" class="section" aria-label="Architects of Lumina">
  <div class="container">
    <div use:reveal>
      <SectionHeader title="Architects of Lumina" />
      <p style="color: var(--muted); font-size: 18px; max-width: 70ch; margin: 8px 0 6px;">Lumina is a collaboration between Arcturian Labs and Maiga:</p>
      <ul style="line-height:1.9; color: var(--muted); font-size: 18px; padding-left: 18px;">
        <li>Arcturian Labs, pioneering agentic venture building on Virtuals</li>
        <li>Maiga, modular intelligence architects of LLM powered agents</li>
        <li>Backed by an experienced team that worked at McKinsey, EY and DBS Bank.</li>
      </ul>
    </div>

    <div class="glass" style="margin-top: 20px; padding: 18px;">
      <div class="marquee">
        <div class="marquee-track" style="width: 200%;">
          {#each [...logos, ...logos] as logo, i}
            <div class="logo-glow" style="display:flex; align-items:center; justify-content:center; min-width: 140px; opacity:.9;">
              <img src={logo.src} alt={logo.alt} style="max-width:120px; max-height:50px; object-fit:contain;" />
            </div>
          {/each}
        </div>
      </div>
    </div>
  </div>
</section>
